import store from "app/store";

const ORDER_STATUSES = [
  "building",
  "waiting_for_customer_approval",
  "waiting_for_company_approval",
  "approved",
  "finished",
  "cancelled",
  "rejected",
  "abandoned",
];

const PRODUCT_TYPES = [
  "Product",
  "Product::Accommodation",
  "Product::Coupon",
  "Product::Standard",
  "Product::Ticket",
  "Product::Voucher",
];

const SOCIALTRAVEL_COMPANY_ID = 100;

const MANAGE_ACTIONS = ["read", "manage", "create", "update", "destroy"];
const UPDATE_ACTIONS = ["manage", "create", "update", "destroy"];

const buildContext = (context = {}) => {
  const user = context.user === undefined ? store.getState().auth.user : context.user;
  const company = context.company === undefined ? store.getState().auth.company.model : context.company;
  const member =
    user && company && user.company_members && user.company_members.find((cm) => cm.company_id === company.id);
  return {
    ...context,
    user,
    company,
    member,
  };
};

function authorize(action, object = {}, context = {}) {
  const { user, company, member } = buildContext(context);

  if (member) {
    if (["stripe"].includes(action) && company.id) {
      return true;
    }

    if (["read"].includes(action) && object.type === "Company" && object.id === company.id) {
      return true;
    }
    if (
      ["read"].includes(action) &&
      object.type === "CompanyMember" &&
      object.company_id === company.id &&
      object.admin_user.id === admin_user.id
    ) {
      return true;
    }

    if (
      ["read", "create", "update", "destroy"].includes(action) &&
      object.type === "Customer" &&
      object.company_id === company.id
    ) {
      return true;
    }
    if (["read"].includes(action) && object.type === "Review" && object.company_id === company.id) {
      return true;
    }

    const payment_profile_ids = company.company_payment_profile_relations.map((rel) => rel.payment_profile.id);
    if (["read"].includes(action) && object.type === "PaymentProfile" && object.main_company_id === company.id) {
      return true;
    }
    if (["read"].includes(action) && object.type === "PaymentProfile" && payment_profile_ids.includes(object.id)) {
      return true;
    }
    if (company.reseller) {
      if (["preview_saas"].includes(action) && PRODUCT_TYPES.includes(object.type)) {
        return true;
      }

      if (["notify_customer"].includes(action) && object.type === "Order") {
        return true;
      }
    }
    if (company.supplier) {
      if (
        ["read", "create", "update", "destroy", "preview_saas", "preview_marketplace"].includes(action) &&
        PRODUCT_TYPES.includes(object.type) &&
        object.company.id === company.id
      ) {
        return true;
      }
      if (
        ["read", "read_manifest", "create", "update", "destroy"].includes(action) &&
        object.type === "ProductScheduleSlot" &&
        object.company_id === company.id
      ) {
        return true;
      }
      if (
        ["create"].includes(action) &&
        object.type === "Order" &&
        object.company_id === company.id &&
        [null, ...company.active_agents_ids].includes(object.agent_id)
      ) {
        return true;
      }
      if (["create_as_supplier"].includes(action) && object.type === "Order") {
        return true;
      }
    }
    if (
      [
        "read",
        "update",
        "update_supplier_note",
        "read_supplier_customer",
        "confirm",
        "approve",
        "reject",
        "finish",
        "cancel",
        "abandon",
        "set_any_status",
        "notify_customer",
      ].includes(action) &&
      object.type === "Order" &&
      object.company_id === company.id
    ) {
      return true;
    }

    if (
      ["read", "preview_saas"].includes(action) &&
      PRODUCT_TYPES.includes(object.type) &&
      company.active_suppliers_products_ids.includes(object.id) &&
      object.status === "published"
    ) {
      return true;
    }
    if (
      ["read"].includes(action) &&
      object.type === "ProductScheduleSlot" &&
      company.active_suppliers_products_ids.includes(object.product_id) &&
      object.active === true
    ) {
      return true;
    }
    if (
      ["read", "update", "update_agent_note", "read_agent_customer", "confirm", "abandon", "notify_customer"].includes(
        action
      ) &&
      object.type === "Order" &&
      object.agent_id === company.id
    ) {
      return true;
    }
    if (
      ["notify_supplier"].includes(action) &&
      object.type === "Order" &&
      (object.agent_id === company.id || object.supplier_id === company.id)
    ) {
      return true;
    }
    const agentManagedStatuses = ORDER_STATUSES.filter((st) => st !== "finished");
    if (
      ["cancel"].includes(action) &&
      object.type === "Order" &&
      object.agent_id === company.id &&
      agentManagedStatuses.includes(object.status)
    ) {
      return true;
    }
    if (
      ["create"].includes(action) &&
      object.type === "Order" &&
      company.active_suppliers_ids.includes(object.company_id) &&
      object.agent_id === company.id
    ) {
      return true;
    }

    if (["global_admin", "main_admin", "editor_admin", "company_admin"].includes(member.role)) {
      if (["update"].includes(action) && object.type === "Company" && object.id === company.id) {
        return true;
      }
      if (
        ["read", "create", "update", "destroy"].includes(action) &&
        object.type === "CompanyMember" &&
        object.company_id === company.id &&
        authorize.managedMemberRoles(context).includes(object.role)
      ) {
        return true;
      }
      if (
        ["read", "create", "update", "destroy"].includes(action) &&
        object.type === "PaymentProfile" &&
        object.main_company_id === company.id &&
        object.marketplace === false
      ) {
        return true;
      }
      if (
        ["read", "update"].includes(action) &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.agent.id === 100
      ) {
        return true;
      }
      if (
        ["read", "update", "destroy", "update_pricing_type"].includes(action) &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.agent.id !== 100
      ) {
        return true;
      }
      if (company.enable_saas) {
        if (["create"].includes(action) && object.type === "AgentCooperation") {
          return true;
        }
      }
      if (
        ["read", "update", "destroy"].includes(action) &&
        object.type === "AgentCooperation" &&
        object.agent.id === company.id
      ) {
        return true;
      }
      if (
        "read_price" === action &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.price_readable_by_supplier === true
      ) {
        return true;
      }
      if (
        "read_price" === action &&
        object.type === "AgentCooperation" &&
        object.agent.id === company.id &&
        object.price_readable_by_agent === true
      ) {
        return true;
      }
      if (
        "update_price" === action &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.price_manageable_by_supplier === true
      ) {
        return true;
      }
      if (
        "update_price" === action &&
        object.type === "AgentCooperation" &&
        object.agent.id === company.id &&
        object.price_manageable_by_agent === true
      ) {
        return true;
      }
      if (
        "read_commision" === action &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.commision_readable_by_supplier === true
      ) {
        return true;
      }
      if (
        "read_commision" === action &&
        object.type === "AgentCooperation" &&
        object.agent.id === company.id &&
        object.commision_readable_by_agent === true
      ) {
        return true;
      }
      if (
        "update_commision" === action &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.commision_manageable_by_supplier === true
      ) {
        return true;
      }
      if (
        "update_commision" === action &&
        object.type === "AgentCooperation" &&
        object.agent.id === company.id &&
        object.commision_manageable_by_agent === true
      ) {
        return true;
      }
      if (
        "read_service_fee" === action &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.service_fee_readable_by_supplier === true
      ) {
        return true;
      }
      if (
        "read_service_fee" === action &&
        object.type === "AgentCooperation" &&
        object.agent.id === company.id &&
        object.service_fee_readable_by_agent === true
      ) {
        return true;
      }
      if (
        "update_service_fee" === action &&
        object.type === "AgentCooperation" &&
        object.supplier.id === company.id &&
        object.service_fee_manageable_by_supplier === true
      ) {
        return true;
      }
      if (
        "update_service_fee" === action &&
        object.type === "AgentCooperation" &&
        object.agent.id === company.id &&
        object.service_fee_manageable_by_agent === true
      ) {
        return true;
      }
    }

    if (["global_admin", "main_admin", "editor_admin"].includes(member.role)) {
      if (["update_payments_settings"].includes(action) && object.id === company.id) {
        return true;
      }
      if (["preview_marketplace"].includes(action) && PRODUCT_TYPES.includes(object.type)) {
        return true;
      }
      if (
        ["update_st_details"].includes(action) &&
        PRODUCT_TYPES.includes(object.type) &&
        object.company.id === company.id
      ) {
        return true;
      }
      if (object.type === "Review" && object.company_id === company.id) {
        return true;
      }
      if (object.type === "PaymentProfile" && object.main_company_id === company.id) {
        return true;
      }
      if (object.type === "PaymentProfile" && payment_profile_ids.includes(object.id)) {
        return true;
      }
      if (object.type === "Order" && object.company_id === company.id) {
        return true;
      }
      if (object.type === "Order" && object.agent_id === company.id) {
        return true;
      }
      if (object.type === "AgentCooperation" && object.supplier.id === company.id) {
        return true;
      }
      if (object.type === "AgentCooperation" && object.agent.id === company.id) {
        return true;
      }

      // FRONTEND
      if (object.type === "NavBarWidget") {
        return true;
      }

      if ("create_agent_disbursement" === action) {
        return true;
      }

      // Settling the platform with a supplier moves Tripsomnia's own money, so it stays
      // with Tripsomnia members - a supplier must not book a payout to itself.
      if ("create_platform_disbursement" === action) {
        return company.id === SOCIALTRAVEL_COMPANY_ID;
      }

      if ("change_status" === action) {
        return true;
      }
    }

    if (["global_admin"].includes(member.role)) {
      if (["read", "preview_saas"].includes(action) && PRODUCT_TYPES.includes(object.type)) {
        return true;
      }
      if (["read"].includes(action) && object.type === "ProductScheduleSlot") {
        return true;
      }
      if (object.type === "Order") {
        return true;
      }
      if (object.type === "Review") {
        return true;
      }
    }
  }

  return false;
}

authorize.managedMemberRoles = (context = {}) => {
  const { user, company, member } = buildContext(context);

  if (member && member.st_admin) {
    return ["global_admin", "main_admin", "editor_admin", "company_admin", "company_employee"];
  } else {
    return ["company_admin", "company_employee"];
  }
};

Object.defineProperties(authorize, {
  user: { get: () => buildContext().user },
  company: { get: () => buildContext().company },
  member: { get: () => buildContext().member },
});

export default authorize;



// WEBPACK FOOTER //
// ./src/lib/utils/authorize.js